import React, { useContext, useEffect, useRef, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import { isEmpty, has, get, each, map } from 'lodash'
import * as PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import Popover from 'react-text-selection-popover'
import { AnnotationContext, BookInfo, MenuContext, SelectionContext, UserInfo } from '../../contexts/menuContext'
import below from './anotation-menu-position'

const BookPage = ({ item, scrollRef, loading, last = false, first = false }) => {
  const [selection, , restoreSelection] = useContext(SelectionContext)
  const [footnotesCollaps, setFootnotesCollaps] = useState(false)
  const [, changeMenuStatus, , changeRightSidebar] = useContext(MenuContext)
  const [, setAnnotationObj, saveSelection] = useContext(AnnotationContext)
  const cleanContent = useRef(null)
  const selectionRef = useRef(null)
  const history = useHistory()
  const [user] = useContext(UserInfo)
  const [book, setBook, page, setPage, forceScroll, setForceScroll] = useContext(BookInfo)
  // const defaultContent = has(item, 'id') ? localStorage.getItem(item.id) : ''
  const { ref, entry } = useInView({
    root: document.querySelector('.book'),
    rootMargin: '0% 0% -85% 0%',
    delay: 200
  })

  useEffect(() => {
    const historyUnlisten = history.listen((location) => {
      // For some reason anchors fire the "POP" action... so we check to make
      // sure that it is NOT an anchor tag before redirecting.
      if (history.action === 'POP' && !get(location, 'hash')) {
        // @todo: At some point we'd like to make the back button smart and
        //        respect links inside a book, however, there are some issues
        //        within the book that is preventing this at this time as
        //        sometimes ONLY the breadcrumbs and the TOC is updated while
        //        the content is not changed.
        // if (has(location, 'state.page_id')) {
        //   let pageType = get(location, 'state.page_type')

        //   if (pageType && pageType !== get(book, 'page_type')) {
        //     setBook({...book, page_type: pageType})
        //   }
        //   setForceScroll(true)
        //   setPage(get(location, 'state.page_id'))
        // }
        // else {
        //   window.location.replace(location.pathname)
        // }
        window.location.replace(location.pathname)
      }
    })

    return () => {
      historyUnlisten();
    }
  })

  useEffect(() => {
    if (!isEmpty(selection) && selection.page === page) {
      restoreSelection(document.querySelector(`.page[data-id="${page}"]`), selection.selection)
      // document.designMode = 'on'
      selectionRef.current.contentEditable = 'true'
      document.execCommand('BackColor', false, '#ff0')
      selectionRef.current.contentEditable = 'false'
      window.getSelection().removeAllRanges()
      // setSelectedZone(selection.page)
      // document.designMode = 'off'
    }
    // getRelation(appendicesMenuUrl).then((data) => { changeAppendicesMenu(data.data[0]) })
    // eslint-disable-next-line
  }, [selection])
  useEffect(() => {
    const links = selectionRef.current.querySelectorAll('sup a')
    const fnlinks = selectionRef.current.querySelectorAll('a.fnref-link')
    if (links.length) {
      each(links, (link) => {
        link.addEventListener('click', anchorLinkClickEventHandler, { once: true })
      })
      each(fnlinks, (link) => {
        link.addEventListener('click', fnAnchorLinkClickEventHandler, { once: true })
      })
      return () => {
        each(links, (link) => {
          link.removeEventListener('click', anchorLinkClickEventHandler)
        })
        each(fnlinks, (link) => {
          link.removeEventListener('click', fnAnchorLinkClickEventHandler)
        }) 
      }
    }
  }, [page])

  const anchorLinkClickEventHandler = (e) => {
    e.currentTarget.removeEventListener(e.type, anchorLinkClickEventHandler);
    setFootnotesCollaps(true)

    const selector = cleanContent.current.querySelector(`li#${e.target.href.replace(/^.*?(#|$)/, '')}`)
    if (get(e, 'target.href', false) && selector) {
      // @todo: This should be a MutationObserver instead, but in the interest
      //        of time this is pretty quick.
      const footNotesExpandedCheck = setInterval(function() {
        if (get(cleanContent.current, 'dataset.collaps')) {
          const activeFootnote = cleanContent.current.querySelector('[data-active="true"]')
          const footnotes = document.querySelector(`#p_${page} .bookreader-footnotes`)
          if (activeFootnote) {
            activeFootnote.dataset.active = 'false'
          }
          selector.dataset.active = 'true'

          const topPos = document.querySelector(`#p_${page}`)?.offsetTop
            - document.querySelector('.control-wrapper').offsetHeight
            - document.querySelector('.bookreader-mobile-mobile-nav').offsetHeight
          const pageTitleHeight = document.querySelector(`#p_${page} h1`).offsetHeight
          // If the footnotes section has not opened yet then scroll to the beginning
          // of the footnotes section only else scroll to the selector's position
          // TODO: Find a better way to improve this.
          const selectorTopPos = (footnotes.offsetHeight > 50 ? selector.offsetTop : footnotes.offsetTop)
          document.querySelector('.book').scroll({top: topPos + selectorTopPos - pageTitleHeight - 10, behavior: "smooth"});
          clearInterval(footNotesExpandedCheck);
        }
      }, 500)

      e.preventDefault()
    }
    return true
  }

  const fnAnchorLinkClickEventHandler = (e) => {
    e.currentTarget.removeEventListener(e.type, fnAnchorLinkClickEventHandler);
    const selector = selectionRef.current.querySelector(`a#${e.target.closest('a').href.replace(/^.*?(#|$)/, '')}`)
    if (get(e, 'currentTarget.href', false) && selector) {
      const topPos = document.querySelector(`#p_${page}`)?.offsetTop
              - document.querySelector('.control-wrapper').offsetHeight
              - document.querySelector('.bookreader-mobile-mobile-nav').offsetHeight
      const pageTitleHeight = document.querySelector(`#p_${page} h1`).offsetHeight
      const selectorTopPos = selector.offsetParent.offsetTop
      document.querySelector('.book').scroll({top: topPos + selectorTopPos - pageTitleHeight - 30, behavior: "smooth"});
      e.preventDefault()
    }
    return true
  }

  useEffect(() => {
    if (page && entry && entry.isIntersecting && !forceScroll && !loading) {
      let pageId = get(item, 'id')
      setPage(pageId)

      let pageTitle = get(item, 'title')
      if (pageTitle) {
        document.title = document.title.replace(/^(.*?) \|/, pageTitle + ' |')
      }

      history.replace(item.url, {page_id: pageId, subsection_type: get(book, 'page_type')})
      sendDataToGa4()
    }
  }, [entry])

  const sendDataToGa4 = () => {
    if (typeof window.gtag === 'undefined' && typeof window.gtag !== 'function') {
      return;
    }

    window.gtag('event', 'page_view', {
      page_title: document.title,
      page_location: document.location.pathname,
      page_path: document.location.pathname,
    })
  }

  const linkClickEventHandler = (e) => {
    e.currentTarget.removeEventListener(e.type, linkClickEventHandler);

    if (get(book, 'id') === get(e.target, 'dataset.idBook')) {
      e.preventDefault()

      let subsectionType = get(e.target, 'dataset.subsectionType')
      let currentBookType = get(book, 'page_type')
      let pageType = 'chapters'

      if (subsectionType !== currentBookType) {
        if (subsectionType === 'appendix') {
          pageType = 'appendices'
          setBook({...book, page_type: pageType})
        }
        else {
          setBook({...book, page_type: pageType})
        }
      }

      let pageId = get(e.target, 'dataset.id')
      let targetUrl = get(e.target, 'url', get(book, 'url'))
      setPage(pageId)
      setForceScroll(true)
      history.push(targetUrl, {page_id: pageId, subsection_type: pageType})

      return false
    }

    return true
  }

  useEffect(() => {
    if (page === get(item, 'id')) {
      let links = selectionRef.current.querySelectorAll('a[data-content-type="subsection"]')

      each(links, (link) => {
        link.addEventListener('click', linkClickEventHandler, { once: true })
      })

      return () => {
        each(links, (link) => {
          link.removeEventListener('click', linkClickEventHandler)
        })
      }
    }
  }, [page])

  return (
    <>
      {!isEmpty(item) &&
      <div
        className="page"
        id={`p_${item.id}`}
        ref={ref}
        data-id={item.id}
      >
        {first && <div >
          <div className="after-position">
            <div className="ph-item" >
              <div className="ph-col-12">
                <div className="ph-row">
                  <div className="ph-col-8 big"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-10"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-8"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-4"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-12"/>
                  <div className="ph-col-10"/>
                </div>
              </div>
            </div>
          </div>
        </div>}
        <div className="selection" ref={selectionRef} data-id={item.id}>
          <div className="flags">
          { (has(item, 'flags') && item.flags.includes('just_updated')) && <div className="ch-flag just-updated">
            <span>
              <svg
                version="1.1"
                viewBox="100 100 300 300"
              >
                <path d="M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2   l-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6   c14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"/>
              </svg>just updated
            </span>
          </div>}
          { (has(item, 'flags') && item.flags.includes('significant_law_change')) && <div className="ch-flag significant-law-change">
            <span>
              <svg
                version="1.1"
                viewBox="100 100 300 300"
              >
                <path d="M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2   l-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6   c14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"/>
              </svg>significant law change
            </span>
          </div>}
          </div>
          <h1>{!isEmpty(item) && has(item, 'title') && item.title}</h1>
          {get(item, 'errors', false) ?
            <div>
              {map(get(item, 'errors'), (err, i) => {
                return <div
                  key={i}
                  dangerouslySetInnerHTML={{ __html: err }}
                />
              })}
            </div> :
            <div
              dangerouslySetInnerHTML={{ __html: item.content.body }}
            />}

          <article
            className="bookreader-footnotes"
            data-collaps={footnotesCollaps}
            ref={cleanContent}
          >

            {!isEmpty(get(item, 'content.footnotes', '')) && <>
              <h4
                onClick={() => {
                  setFootnotesCollaps(!footnotesCollaps)
                }}
              ><span>Footnotes</span> <svg
                width="1em"
                height="1em"
                viewBox="0 0 16 16"
                className="bi bi-caret-left-fill"
                fill="currentColor"
              >
                <path
                  d="M3.86 8.753l5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                />
              </svg>
              </h4>
              <div
                dangerouslySetInnerHTML={{ __html: item.content.footnotes }}
              />
                                                             </>
        }
            {get(user, 'id', 0) > 0 && (['chapters', 'index', 'appendices'].includes(get(book, 'page_type', ''))) && get(item, 'url', false) &&
            <Popover
              selectionRef={selectionRef}
              scrollRef={scrollRef}
              placementStrategy={below}
              gap={10}
            >
              <button
                type="button"
                className="btn btn-default popover"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Add annotation"
                onClick={() => {
                  const id = selectionRef.current.dataset.id;
                  setAnnotationObj({
                    page: id,
                    selection: saveSelection(document.querySelector(`.page[data-id="${id}"]`)),
                    text: window.getSelection().toString(),
                  })
                  const sel = window.getSelection()
                  if (!sel.focusNode) {
                    return false
                  }
                  const selScroll = get(sel, 'focusNode.parentElement')
                  if (selScroll && window.innerWidth > 1024) {
                    selScroll.scrollIntoView({ alignToTop: true, block: 'center' })
                  }
                  changeRightSidebar('annotation')
                  changeMenuStatus(false)
                }}
              >
                <div className="icon-wrap">
                  <span className="svg-icon"><svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    className="annotator-adder-button__icon"
                  >
                    <path
                      fill="currentColor"
                      fillRule="nonzero"
                      d="M15 0c.27 0 .505.099.703.297A.961.961 0 0116 1v15l-4-3H1a.974.974 0 01-.703-.29A.953.953 0 010 12V1C0 .719.096.482.29.29A.966.966 0 011 0h14zM7 3l-.469.063c-.312.041-.656.187-1.031.437-.375.25-.719.646-1.031 1.188C4.156 5.229 4 6 4 7l.002.063.006.062a.896.896 0 01.008.11l-.002.074-.006.066a1.447 1.447 0 00.43 1.188C4.729 8.854 5.082 9 5.5 9c.417 0 .77-.146 1.063-.438C6.854 8.271 7 7.918 7 7.5c0-.417-.146-.77-.438-1.063A1.447 1.447 0 005.5 6c-.073 0-.146.005-.219.016-.073.01-.14.026-.203.046.177-1.03.542-1.632 1.094-1.804L7 4V3zm5 0l-.469.063c-.312.041-.656.187-1.031.437-.375.25-.719.646-1.031 1.188C9.156 5.229 9 6 9 7l.002.063.006.062a.896.896 0 01.008.11l-.002.074-.006.066a1.447 1.447 0 00.43 1.188c.291.291.645.437 1.062.437.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.447 1.447 0 0010.5 6c-.073 0-.146.005-.219.016-.073.01-.14.026-.203.046.177-1.03.542-1.632 1.094-1.804L12 4V3z"
                    />
                                             </svg>
                  </span>
                  <span className="annotator-adder-button__label">Annotate</span>
                </div>
              </button>

            </Popover>}
          </article>
          {last && <div >
            <div className="after-position">
              <div className="ph-item" >
                <div className="ph-col-12">
                  <div className="ph-row">
                    <div className="ph-col-8 big"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-10"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-8"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-4"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-12"/>
                    <div className="ph-col-10"/>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        </div>

      </div>
      }
    </>
  )
}
BookPage.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
}

export default BookPage
